import styled from "styled-components";
import Backdrop from "../Backdrop";
import theme from "../../theme/theme";

const BodyWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalBody = styled.div`
  max-width: 500px;
  width: 100%;
  background-color: white;
  padding: 40px 40px;
  border-radius: 15px;
  text-align: center;

  @media (max-width: 480px) {
    width: 80%;
    margin: auto;
    padding: 20px 20px;
  }

  .headerMessage {
    font-weight: 700;
    font-size: 32px;
    color: ${theme.colors.primaryStrong2X};

    .crossButton {
      float: right;
      font-size: 20px;
      cursor: pointer;

      @media (max-width: 480px) {
        font-size: 18px;
      }
    }

    @media (max-width: 480px) {
      font-size: 18px;
    }
  }

  .congratMessage {
    font-weight: 700;
    font-size: 32px;
    padding: 0px 100px;
    margin-top: 50px;
    color: ${theme.colors.primaryStrong2X};
    @media (max-width: 480px) {
      padding: 0;
      margin-top: 0;
    }
  }

  .subHeaderMessage {
    margin-top: 20px;
    font-size: 17px;
    padding: 0px 100px;
    color: ${theme.colors.primaryStrong2X};
    display: flex;
    flex-direction: column;
    align-items: center;
    @media (max-width: 480px) {
      font-size: 14px;
    }
  }
`;

const ContactAdvisorPopup = (props) => {
  return (
    <Backdrop>
      <BodyWrapper>
        <ModalBody>
          <div className="headerMessage">
            {" "}
            <div onClick={props.onClose} className="crossButton">
              X
            </div>
          </div>
          <div className="congratMessage">Contact Your Advisor</div>
          <div className="subHeaderMessage">
            Advisor Email:{" "}
            {props.advisorEmail || "acccountsupport@tactivewealth.com"}
          </div>
        </ModalBody>
      </BodyWrapper>
    </Backdrop>
  );
};

export default ContactAdvisorPopup;
